import { classicLink } from '~/styles/app.css'

export const transformUrlIntoLink = (text: string) => {
  const parts = text.split(/(https?:\/\/[^\s]+)/g)

  if (parts.length === 1) {
    return text
  }

  return parts.map((part, index) =>
    part.startsWith('http') ? (
      <a
        // biome-ignore lint/suspicious/noArrayIndexKey: split parts are stable
        key={`${index}-${part}`}
        href={part}
        className={classicLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        {part}
      </a>
    ) : (
      part
    )
  )
}
